import { Batch } from './batch';
import { Campus } from './campus';
import { Student } from './users';

export class Team {
    id: number;
    name: string;
    batch: Batch;
    campus: Campus;
    members: Student[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/team.ts